
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.091-.45-.254-.611zm-1.755.69h-6.325V2.978l6.325 6.324zM6.009 31.27V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27H6.009z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm0 3.901h14.5a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm.999 10.959l-2.211-5.518H7.386v6.763h.892v-2.634l-.089-2.828 2.216 5.462h.683l2.221-5.476-.084 2.842v2.634h.892v-6.763H12.96m6.646.299c-.413-.261-.892-.393-1.434-.393-.532 0-1.005.133-1.418.397-.413.266-.733.647-.96 1.146-.226.498-.339 1.072-.339 1.723v.488c.007.638.124 1.2.351 1.684.227.485.547.858.959 1.119.412.262.884.394 1.417.394.546 0 1.022-.131 1.43-.391.409-.259.725-.637.948-1.13.223-.495.335-1.072.335-1.736v-.427c0-.659-.112-1.238-.335-1.735-.223-.497-.541-.877-.954-1.139zm.401 3.366c-.01.783-.172 1.385-.488 1.804-.316.419-.762.63-1.338.63-.573 0-1.022-.223-1.349-.668-.327-.445-.49-1.055-.49-1.833v-.496c.01-.762.176-1.358.5-1.787.323-.429.767-.643 1.33-.643.579 0 1.03.214 1.352.643.323.429.483 1.045.483 1.847v.503zm4.362 1.914l-1.923-5.579h-.971l2.504 6.763h.79l2.508-6.763h-.976"}})])])
          )
        }
      }
    